import React, { useEffect, useState } from 'react';
import './Customer.css';
import { useTheme } from '../theme/ThemeContext';
import DataTable from 'react-data-table-component';
import LoadingSpinner from '../Loading/LoadingSpinner';
import NotificationPopup from '../alertpopup/NotificationPopup';
const Customer = () => {
  const token = localStorage.getItem('authToken')

  const backendurl = window.location.hostname === 'localhost'
    ? ''
    : window.location.hostname === 'demo.ollinwon.com'
      ? process.env.REACT_APP_BACKEND_URL
      : window.location.hostname === 'iot.aizoteq.com'
        ? process.env.REACT_APP_BACKEND_URL2
        : '';

  const { theme } = useTheme();
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSlide, setShowSlide] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('customers');
  const [userData, setUserData] = useState({})
  const [customerBillPopup, setCustomerBillPopup] = useState(false)
  const [billingData, setBillingData] = useState(null)
  const [loading, setLoading] = useState({
    mainData: true,
    billingData: false,
    userData: true,
    payment: false
  });
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [customerSelectedBill, setCustomerSelectedBill] = useState(null)
  const [customerViewBillPopup, setCustomerViewBillPopup] = useState(false)
  const [groupedItemsArray, setgroupedItemsArray] = useState([])
  const [balancePayPopup, setBalancePayPopup] = useState(false)
  const [inputValue, setInputValue] = useState("");
  const [paymentEntries, setPaymentEntries] = useState([]);
  const [balanceamount, setBalance] = useState([]);
  const [message, setMessage] = useState("");

  // Notification state
  const [notification, setNotification] = useState({
    show: false,
    type: "success",
    message: "",
    title: ""
  });

  // Notification helper function
  const showNotification = (type, message, title = "", duration = 3000) => {
    setNotification({
      show: true,
      type,
      message,
      title
    });

    setTimeout(() => {
      setNotification(prev => ({ ...prev, show: false }));
    }, duration);
  };


  const handleBalanceCancel = () => {
    setBalancePayPopup(false)
    setPaymentEntries([])
    showNotification("info", "Payment cancelled", "Payment Cancelled");
  }

  const fetchBillingData = async (row) => {
    setBalance(row)
    setLoading(prev => ({ ...prev, billingData: true }));

    try {
      const response = await fetch(`${backendurl}/dashboard/api/billing/${selectedFilter}/${row.id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch billing data");
      }

      const result = await response.json();
      setBillingData(result.data);
      setCustomerBillPopup(true);
      showNotification("success", "Billing data loaded successfully");

    } catch (err) {
      setError(err.message);
      showNotification("error", "Failed to load billing data", "Load Error");
    } finally {
      setLoading(prev => ({ ...prev, billingData: false }));
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${backendurl}/api/display/user`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        console.log("User  data fetched successfully:", data);
        setUserData(data);
      } else {
        console.error("Failed to fetch user data.");
        showNotification("warning", "Failed to load user profile", "Load Warning");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      showNotification("error", "Error loading user profile", "Network Error");
    } finally {
      setLoading(prev => ({ ...prev, userData: false }));
    }
  };

  const handleSlide = () => {
    setShowSlide((prev) => !prev);
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setShowSlide(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(prev => ({ ...prev, mainData: true }));

      try {
        let endpoint = '';
        if (selectedFilter === 'customers') {
          endpoint = `${backendurl}/dashboard/api/display/party/customers?query=${searchQuery}`;
        } else if (selectedFilter === 'online customers') {
          endpoint = `${backendurl}/dashboard/api/display/party/onlinecustomer?query=${searchQuery}`;
        } else if (selectedFilter === 'dealers') {
          endpoint = `${backendurl}/dashboard/api/display/party/dealers?query=${searchQuery}`;
        }

        const options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        };

        const response = await fetch(endpoint, options);
        if (!response.ok) throw new Error('Failed to fetch data');
        const result = await response.json();
        const data = result?.data || [];
        setData(data);

        if (data.length === 0) {
          showNotification(
            "info",
            `No ${selectedFilter} records found`
          );
        } else {
          showNotification(
            "success",
            `${selectedFilter} data loaded successfully`
          );
        }
        // setData(result.data);
        // showNotification("success", `${selectedFilter} data loaded successfully`);
      } catch (error) {
        console.error('Error fetching data:', error);
        showNotification("error", `Failed to load ${selectedFilter} data`, "Load Error");
      } finally {
        setLoading(prev => ({ ...prev, mainData: false }));
      }
    };

    fetchData();
  }, [searchQuery, selectedFilter]);

  let customertype = '';
  if (selectedFilter === 'customers') {
    customertype = 'Customers Details';
  } else if (selectedFilter === 'online customers') {
    customertype = 'Online Customers';
  } else if (selectedFilter === 'dealers') {
    customertype = 'Dealers Details';
  }

  const columns = [
    {
      name: 'ID',
      selector: (row, index) => index + 1,
      sortable: true
    },
    { name: 'Name', selector: (row) => row.name || 'null', sortable: true },
    { name: 'Address', selector: (row) => row.address || 'null', sortable: true },
    { name: 'Phone', selector: (row) => row.phone || 'null', sortable: true },
    { name: 'Alt Phone', selector: (row) => row.alt_phone || 'null', sortable: true },
    { name: 'Total Amount', selector: (row) => row.total_amount || 'null', sortable: true },
    { name: 'Balance', selector: (row) => row.balance || 'null', sortable: true },
    { name: 'Last Modified', selector: (row) => row.lastmodified || 'null', sortable: true },
    { name: 'Email', selector: (row) => row.email || 'null', sortable: true },
    { name: 'Paid Amount', selector: (row) => row.paid_amount || 'null', sortable: true },
    { name: 'Refund Amount', selector: (row) => row.refund_amount || 'null', sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div className="bill-history-action">
          <button
            className="view-button1"
            onClick={() => fetchBillingData(row)}
            disabled={loading.billingData}
          >
            {loading.billingData ? (
              <LoadingSpinner size="small" text="" color="primary" />
            ) : (
              <i className="fa-solid fa-receipt"></i>
            )}
          </button>
        </div>
      ),
    },
  ];

  const customerBill = [
    { name: "ID", selector: (row, index) => index + 1, sortable: true },
    { name: "Invoice No", selector: (row) => row.receipt_no || "-", sortable: true },
    { name: "Name", selector: (row) => row.entity_name || "-", sortable: true },
    { name: "Total Amount", selector: (row) => row.payable_amount || "-", sortable: true },
    { name: "Paid Amount", selector: (row) => row.paid_amount || "-", sortable: true },
    { name: "Balance", selector: (row) => row.balance || "-", sortable: true },
    {
      name: "Date",
      selector: (row) => row.receipt_date ? row.receipt_date.split("T")[0] : "-",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="bill-history-action">
          <button
            className="view-button"
            onClick={() => handlecustomerBill(row)}
          >
            View Details
          </button>
        </div>
      ),
    },
  ];

  const handlecustomerBill = (row) => {
    setCustomerSelectedBill(row)
    const groupedItems = row.items?.reduce((acc, item) => {
      const key = item.model;
      if (!acc[key]) {
        acc[key] = { ...item, quantity: 1 };
      } else {
        acc[key].quantity += 1;
        acc[key].mrp = parseFloat(acc[key].mrp) + parseFloat(item.mrp);
        acc[key].item_discount = parseFloat(acc[key].item_discount) + parseFloat(item.item_discount);
        acc[key].final_price = parseFloat(acc[key].final_price) + parseFloat(item.final_price);
        acc[key].cgst = parseFloat(acc[key].cgst) + parseFloat(item.cgst);
        acc[key].sgst = parseFloat(acc[key].sgst) + parseFloat(item.sgst);
        acc[key].igst = parseFloat(acc[key].igst) + parseFloat(item.igst);
      }
      return acc;
    }, {});

    setgroupedItemsArray(Object.values(groupedItems))
    setCustomerViewBillPopup(true)
  }

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB");

  const handleButtonClick = (value) => {
    if (value === "C") {
      setInputValue("");
    } else {
      setInputValue((prev) => prev + value);
    }
  };

  const handlePaymentMethodClick = (method) => {
    if (inputValue.trim() === "" || isNaN(inputValue)) {
      showNotification("warning", "Please enter a valid amount", "Invalid Amount");
      return;
    }

    const newEntry = { method, amount: parseFloat(inputValue) };
    setPaymentEntries((prevEntries) => [...prevEntries, newEntry]);
    setInputValue("");
    showNotification("success", `Added ${method} payment of ₹${parseFloat(inputValue).toFixed(2)}`);
  };

  const collectedAmount = paymentEntries.reduce((sum, entry) => sum + entry.amount, 0).toFixed(2);
  const balance = data
    ? (parseFloat(balanceamount.balance || 0) - parseFloat(collectedAmount)).toFixed(2)
    : "0.00";

  const handlePayment = async () => {
    if (paymentEntries.length === 0) {
      showNotification("warning", "Please add at least one payment method", "No Payments");
      return;
    }

    setLoading(prev => ({ ...prev, payment: true }));
    setMessage("");

    const requestData = {
      id: balanceamount.id,
      type: selectedFilter,
      payments: paymentEntries || [],
      created_by: userData.userrole,
    };

    try {
      const response = await fetch(`${backendurl}/dashboard/api/pay-balance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        showNotification("success", `Payment successful! Receipt ID: ${data.receiptId}`, "Payment Success");
        setMessage(`Payment successful! Receipt ID: ${data.receiptId}`);
        setBalancePayPopup(false);
        setPaymentEntries([]);
        // Refresh data
        const fetchData = async () => {
          try {
            let endpoint = '';
            if (selectedFilter === 'customers') {
              endpoint = `${backendurl}/dashboard/api/display/party/customers?query=${searchQuery}`;
            } else if (selectedFilter === 'online customers') {
              endpoint = `${backendurl}/dashboard/api/display/party/onlinecustomer?query=${searchQuery}`;
            } else if (selectedFilter === 'dealers') {
              endpoint = `${backendurl}/dashboard/api/display/party/dealers?query=${searchQuery}`;
            }

            const options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              }
            };

            const response = await fetch(endpoint, options);
            if (!response.ok) throw new Error('Failed to fetch data');
            const result = await response.json();
            setData(result.data);
          } catch (error) {
            console.error('Error refreshing data:', error);
          }
        };
        fetchData();
      } else {
        showNotification("error", `Error: ${data.error}`, "Payment Failed");
        setMessage(`Error: ${data.error}`);
      }
    } catch (error) {
      showNotification("error", "An error occurred. Please try again.", "Network Error");
      setMessage("An error occurred. Please try again.");
    } finally {
      setLoading(prev => ({ ...prev, payment: false }));
    }
  };

  // Check if any loading is happening
  const isLoading = Object.values(loading).some(value => value === true);

  return (
    <div className={`customer-main ${theme}-theme`}>
      {/* Show fullscreen loading spinner */}
      {/* {isLoading && (
        <LoadingSpinner 
          fullScreen={true} 
          text="Loading customer data..."
          color={theme === "dark" ? "primary" : "primary"}
        />
      )} */}

      {/* Show notification popup */}
      <NotificationPopup
        show={notification.show}
        type={notification.type}
        message={notification.message}
        title={notification.title}
        onClose={() => setNotification({ ...notification, show: false })}
        duration={5000}
      />

      <div className="dash-dummy"></div>
      <div className="second-main">
        <div className="customer-content-main">
          <div className="customer-content-nav">
            <div className="customer-content-head">
              <p>{customertype}</p>
            </div>
            <div className="customer-content-items">
              <div className="device-search">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  disabled={loading.mainData}
                />
                {loading.mainData && (
                  <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    {/* <LoadingSpinner size="small" color="primary" /> */}
                  </div>
                )}
              </div>
              <div style={{ position: 'relative' }}>
                <i
                  className="fa-solid fa-sliders"
                  onClick={handleSlide}
                  style={{ cursor: loading.mainData ? 'not-allowed' : 'pointer', opacity: loading.mainData ? 0.6 : 1 }}
                ></i>
                {showSlide && (
                  <div className="customer-slide-menu show">
                    {['customers', 'online customers', 'dealers'].map((filter) => (
                      <div
                        key={filter}
                        className="thing-slide-item"
                        onClick={() => !loading.mainData && handleFilterChange(filter)}
                        style={{ cursor: loading.mainData ? 'not-allowed' : 'pointer', opacity: loading.mainData ? 0.6 : 1 }}
                      >
                        <span>{filter}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {loading.mainData ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '300px',
              width: '100%',
              background: theme === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
              borderRadius: '8px',
              marginTop: '20px'
            }}>
              <LoadingSpinner size="medium" text="Loading customer data..." color="primary" />
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data}
              fixedHeader
              pagination
              progressPending={loading.mainData}
              progressComponent={<div style={{ padding: '20px' }}><LoadingSpinner size="medium" text="Loading..." color="primary" /></div>}
            />
          )}

          {customerBillPopup && (
            <div className="bill-popup-overlay">
              <div className="bill-cusbill-popup-content">
                <button
                  className="bill-popup-close"
                  onClick={() => setCustomerBillPopup(false)}
                  disabled={loading.billingData || loading.payment}
                >
                  <i className="fa-solid fa-x"></i>
                </button>
                <div className="bill-customer-bill-search">
                  <div className="bill-estimate-model-search">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                      type="search"
                      placeholder="Search...."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      disabled={loading.billingData}
                    />
                    {loading.billingData && (
                      <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                        <LoadingSpinner size="small" color="primary" />
                      </div>
                    )}
                  </div>
                </div>

                <div className="bill-customer-table">
                  {loading.billingData ? (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '300px',
                      width: '100%'
                    }}>
                      <LoadingSpinner size="medium" text="Loading billing data..." color="primary" />
                    </div>
                  ) : error ? (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '300px',
                      color: theme === 'dark' ? '#e74c3c' : '#c0392b'
                    }}>
                      <p>Error: {error}</p>
                    </div>
                  ) : (
                    <DataTable columns={customerBill} data={billingData} pagination fixedHeader />
                  )}
                </div>
                <div className="bill-customer-balance-pay">
                  <div className="bill-customer-balance-box">
                    <p>Total Amount: </p>
                    <p> ₹ {balanceamount.total_amount}</p>
                  </div>
                  <div className="bill-customer-balance-box">
                    <p>Paid Amount:</p>
                    <p>₹ {balanceamount.paid_amount}</p>
                  </div>
                  <div className="bill-customer-balance-box">
                    <p>Balance:</p>
                    <p>₹ {balanceamount.balance}</p>
                  </div>
                  <button
                    onClick={() => setBalancePayPopup(true)}
                    disabled={loading.billingData}
                  >
                    Pay Balance
                  </button>
                </div>

                {balancePayPopup && (
                  <div className="bill-popup-overlay">
                    <div className="bill-popup-content">
                      <button
                        className="bill-popup-close"
                        onClick={() => setBalancePayPopup(false)}
                        disabled={loading.payment}
                      >
                        <i className="fa-solid fa-x"></i>
                      </button>
                      <div className="bill-payment-main">
                        <div className="bill-payment-calculate-main">
                          <div className="bill-payment-calculate">
                            <input
                              type="number"
                              value={inputValue}
                              onChange={(e) => setInputValue(e.target.value)}
                              autoFocus
                              disabled={loading.payment}
                            />
                            <div className="bill-payment-calculate-btn-main">
                              {[
                                ["7", "8", "9"],
                                ["4", "5", "6"],
                                ["1", "2", "3"],
                                ["0", ".", "C"],
                              ].map((row, rowIndex) => (
                                <div className="bill-payment-calculate-btn" key={rowIndex}>
                                  {row.map((btnValue) => (
                                    <input
                                      key={btnValue}
                                      type="button"
                                      value={btnValue}
                                      className={btnValue === "C" ? "clear" : ""}
                                      onClick={() => !loading.payment && handleButtonClick(btnValue)}
                                      disabled={loading.payment}
                                    />
                                  ))}
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="bill-payment-method-main">
                            <div
                              className="bill-payment-method-box"
                              onClick={() => !loading.payment && handlePaymentMethodClick("cash")}
                              style={{ cursor: loading.payment ? 'not-allowed' : 'pointer', opacity: loading.payment ? 0.6 : 1 }}
                            >
                              <h2>CASH</h2>
                            </div>
                            <div
                              className="bill-payment-method-box"
                              onClick={() => !loading.payment && handlePaymentMethodClick("bank")}
                              style={{ cursor: loading.payment ? 'not-allowed' : 'pointer', opacity: loading.payment ? 0.6 : 1 }}
                            >
                              <h2>BANK</h2>
                            </div>
                            <div
                              className="bill-payment-method-box"
                              onClick={() => !loading.payment && handlePaymentMethodClick("online")}
                              style={{ cursor: loading.payment ? 'not-allowed' : 'pointer', opacity: loading.payment ? 0.6 : 1 }}
                            >
                              <h2>GOOGLE PAY</h2>
                            </div>
                          </div>
                        </div>
                        <div className="bill-payment-method-table-main">
                          <div className="bill-payment-table-div">
                            <table>
                              <thead>
                                <tr>
                                  <th>Description</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paymentEntries.map((entry, index) => (
                                  <tr key={index}>
                                    <td>{entry.method}</td>
                                    <td>₹ {entry.amount.toFixed(2)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="bill-payment-amount-calculate">
                            <div className="bill-payment-invoice-value">
                              <p>Balance Value :</p>
                              <div className="bill-payment-amount-box">
                                <span>₹ {balanceamount.balance || "0.00"}</span>
                              </div>
                            </div>

                            <div className="bill-payment-invoice-value">
                              <p>Collected :</p>
                              <div className="bill-payment-amount-box-1">
                                <p>₹ {collectedAmount}</p>
                              </div>
                            </div>

                            <div className="bill-payment-invoice-value">
                              <p>Balance :</p>
                              <div className="bill-payment-amount-box-2">
                                <p>₹ {balance}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bill-payment-save-buttons">
                        <button
                          onClick={handlePayment}
                          disabled={loading.payment || paymentEntries.length === 0}
                        >
                          {loading.payment ? <LoadingSpinner size="small" text="" color="primary" /> : "Accept"}
                        </button>
                        <button
                          onClick={handleBalanceCancel}
                          disabled={loading.payment}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => setPaymentEntries([])}
                          disabled={loading.payment}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {customerViewBillPopup && (
            <div className="bill-popup-overlay">
              <div className="bill-details-popup-content">
                <button className="bill-popup-close" onClick={() => setCustomerViewBillPopup(false)}>
                  <i className="fa-solid fa-x"></i>
                </button>
                <div className="bill-details-popup-content-main">
                  <div className="bill-details-customer-details">
                    <div className="bill-details-customer-bill-address">
                      <h3>Bill to:</h3>
                      <p>{customerSelectedBill.entity_name}</p>
                      <p>{customerSelectedBill.billing_address}</p>
                      <p>Contact: {customerSelectedBill.phone}</p>
                      <p>GSTIN: {customerSelectedBill.gstin || "N/A"}</p>
                      <div className="bill-details-customer-invoice">
                        <p>
                          <strong>Invoice No:</strong> {customerSelectedBill.receipt_no}
                        </p>
                      </div>
                    </div>
                    <div className="bill-details-customer-shipp-address">
                      <h3>Ship to:</h3>
                      <p>{customerSelectedBill.shipping_address}</p>
                      <p>Contact: {customerSelectedBill.phone}</p>
                      <div className="bill-details-customer-invoice">
                        <p>
                          <strong>Date:</strong> {formattedDate}
                        </p>
                      </div>
                    </div>
                  </div>

                  <table>
                    <thead>
                      <tr>
                        <th>Serial No</th>
                        <th>Model</th>
                        <th>Qty</th>
                        <th>MRP</th>
                        <th>Discount</th>
                        <th>Taxable Value</th>
                        <th>Tax</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedItemsArray.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.model}</td>
                          <td>{item.quantity}</td>
                          <td>₹ {parseFloat(item.mrp).toFixed(2)}</td>
                          <td>₹ {parseFloat(item.item_discount).toFixed(2)}</td>
                          <td>₹ {(parseFloat(item.mrp) - parseFloat(item.item_discount)).toFixed(2)}</td>
                          <td>₹ {parseFloat(item.cgst + item.sgst + item.igst).toFixed(2)}</td>
                          <td>₹ {parseFloat(item.final_price).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan="3">Total</th>
                        <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.mrp), 0).toFixed(2)}</th>
                        <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.item_discount), 0).toFixed(2)}</th>
                        <th>₹ {groupedItemsArray.reduce((sum, item) => sum + (parseFloat(item.mrp) - parseFloat(item.item_discount)), 0).toFixed(2)}</th>
                        <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.cgst + item.sgst + item.igst), 0).toFixed(2)}</th>
                        <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.final_price), 0).toFixed(2)}</th>
                      </tr>
                    </tfoot>
                  </table>
                  <div className="bill-history-payment-details">
                    <div className="bill-history-payment">
                      <p>Total Amount :</p>
                      <p>₹ {customerSelectedBill.total_amount}</p>
                    </div>
                    <div className="bill-history-payment">
                      <p>Paid Amount :</p>
                      <p>₹ {customerSelectedBill.paid_amount}</p>
                    </div>
                    <div className="bill-history-payment">
                      <p>Balance :</p>
                      <p>₹ {customerSelectedBill.balance}</p>
                    </div>
                    <div className="bill-history-payment-method">
                      <p>Payment Method :</p>
                      <div className="bill-payment-methods">
                        {customerSelectedBill.payments?.length > 0 ? (
                          customerSelectedBill.payments.map((payment, index) => (
                            <div key={index} className="bill-payment-method">
                              <p>{payment.payment_method} : ₹ {payment.payment_amount}</p>
                            </div>
                          ))
                        ) : (
                          <p>N/A</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Customer;